<span>

    @switch (advanceState) {
    @case (1) {
    <span style="color: cornflowerblue;" class="indicator">
        <mat-icon style="color: cornflowerblue;" class="midd" mat-list-icon>
            smartphone
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Создан (1) </small>
    </span>
    <span *ngIf="withInfo"> - Агент создал ПКО, есть возможность редактировать, подтвердить или удалить. </span>
    }
    @case (2) {
    <span style="color: rgb(255, 140, 0);" class="indicator">
        <mat-icon style="color: rgb(255, 140, 0);" class="midd" mat-list-icon>
            smartphone
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Подтвержден (2)</small>
    </span>
    <span *ngIf="withInfo"> - Все изменения в ПКО проверены, правильность подтверждена агентом. Для отправки в
        1С необходимо синхронизироваться.. </span>
    }
    @case (3) {
    <span style="color: green;" class="indicator">
        <mat-icon style="color: green;" class="midd" mat-list-icon fontSet="material-icons-outlined">
            cloud_upload
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Отправлен в 1с (3)</small>
    </span>
    <span *ngIf="withInfo"> - ПКО успешно передан в 1С, ожидается создание в 1С. </span>
    }
    @case (4) {
    <span style="color: green;" class="indicator">
        <mat-icon style="color: green;" class="midd" mat-list-icon>
            check_circle_outline
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Проведен в 1с (4). </small>
    </span>
    <span *ngIf="withInfo"> - Деньги приняты кассой. ПКО проведён в 1с. </span>

    }
    @case (5) {
    <span style="color: rgb(255, 140, 0);" class="indicator">
        <mat-icon style="color: rgb(255, 140, 0);" class="midd" mat-list-icon fontSet="material-icons-outlined">
            cloud_upload
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Выгружен (5)</small>
    </span>
    <span *ngIf="withInfo"> - После подтверждения агентом и последующей синхронизации ПКО уходит на сервер,
        который передаёт его в 1С. </span>
    }
    @case (6) {
    <span style="color: red" class="indicator">
        <mat-icon style="color: red" class="midd" mat-list-icon>
            error_outline
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Ошибка в 1с (6)</small>
    </span>
    <span *ngIf="withInfo"> - При проведении произошла ошибка. Текст ошибки виден в комментарии. </span>
    }
    @case (7) {
    <span style="color: rgb(255, 140, 0);" class="indicator">
        <mat-icon style="color: rgb(255, 140, 0);" class="midd" mat-list-icon>
            check_circle_outline
        </mat-icon>
        <small class="status-indicator-text" *ngIf="withText"> Создан в 1с (7)</small>
    </span>
    <span *ngIf="withInfo"> - 1С приняла ПКО, ожидает внесения денежных средств. </span>

    }
    @default {
    Не известный статус {{advanceState}}
    }
    }
    

</span>